import { IsoCodeServiceConfig } from '../../types/ServiceConfigurations';

class IsoCodeService {
  public static activeCountries: Array<{
    CountryName: string;
    IsoCode: string;
  }> = [];

  private storeUrl: string;

  private storedCountries: Array<{ CountryName: string; IsoCode: string }> = [];

  constructor(config?: IsoCodeServiceConfig) {
    this.storeUrl = config ? config.apiUrl : '';
  }

  public getIsoCodeFromName = async (
    countryName: string
  ): Promise<string | null> => {
    await this.populateCountries();
    const match = this.storedCountries.find(
      country => country.CountryName === countryName
    );
    return match?.IsoCode ?? null;
  };

  public getNameFromIsoCode = async (
    isoCode: string
  ): Promise<string | null> => {
    await this.populateCountries();
    const match = this.storedCountries.find(
      country => country.IsoCode === isoCode
    );
    return match?.CountryName ?? null;
  };

  private populateCountries = async (): Promise<void> => {
    if (this.storedCountries.length) return;

    const response = await window.fetch(
      `${this.storeUrl}/net/AmazonPaymentEndpoint.ashx?Method=GetActiveCountries`,
      {
        method: 'GET',
      }
    );
    if (response.status === 200) {
      const result = await response.json();
      this.storedCountries = result.activeCountries;
    }
  };

  // old static methods, to be removed during UX-Update-2 cleanup
  public static populateActiveCountryList = async (): Promise<void> => {
    const response = await window.fetch(
      `../net/AmazonPaymentEndpoint.ashx?Method=GetActiveCountries`,
      {
        method: 'GET',
      }
    );
    if (response.status === 200) {
      const result = await response.json();
      IsoCodeService.activeCountries = result.activeCountries;
    }
  };

  public static getIsoCodeFromName = async (
    countryName: string
  ): Promise<string | null> => {
    let code: string | null = null;
    if (
      !IsoCodeService.activeCountries ||
      !IsoCodeService.activeCountries.length
    ) {
      await IsoCodeService.populateActiveCountryList();
    }
    if (Array.isArray(IsoCodeService.activeCountries)) {
      IsoCodeService.activeCountries.forEach(entry => {
        if (entry.CountryName === countryName) {
          code = entry.IsoCode;
        }
      });
    }
    return code;
  };

  public static getNameFromIsoCode = async (
    isoCode: string
  ): Promise<string | null> => {
    let foundName: string | null = null;
    if (
      !IsoCodeService.activeCountries ||
      !IsoCodeService.activeCountries.length
    ) {
      await IsoCodeService.populateActiveCountryList();
    }
    if (Array.isArray(IsoCodeService.activeCountries)) {
      IsoCodeService.activeCountries.forEach(entry => {
        if (entry.IsoCode === isoCode) {
          foundName = entry.CountryName;
        }
      });
    }
    return foundName;
  };
}

export default IsoCodeService;
